<main class="eixo" id="eixo">
  <h1 class="title container">{{ eixo.nome }}</h1>
  <div id="banner" class="banner container" role="banner">
    <img src="/assets/comprimidas/{{ eixo.id }}/{{ eixo.imagem }}" alt="{{ eixo.nome }}" class="banner"
      [ngStyle]="{ opacity: !encurtarTexto ? '0.5' : '1' }" />
    <div class="desc-container container">
      <p class="float-text text-justify" [ngClass]="{ grow: !encurtarTexto }" #descricao>
        {{ encurtarTexto ? (eixo.descricao | shorten) : eixo.descricao }}
      </p>
      <button (click)="encurtarTexto = !encurtarTexto" appFocarTexto class="btn ver-mais"
        [ngClass]="{ 'ver-menos': !encurtarTexto }">
        {{ !encurtarTexto ? 'ver menos' : 'ver mais' }}
      </button>
    </div>
  </div>

  <!-- Áreas tecnológicas -->
  <div class="container">
    <div style="display: flex; align-items: center;">
      <div style="width: 48px; height: 48px;"></div>
      <button class="btn-area rounded-pill btn-lg btn-primary" (click)="showAreasTecnologicas()">
        Áreas Tecnológicas
      </button>
      <div style="width: 48px; height: 48px;"></div>
    </div>

    <p class="text-center warning-areas subtitle" *ngIf="mostrarMsgSemArea">{{ msgSemArea }}</p>

    <div *ngIf="areasTecnologicas.length > 0 && mostrarAreasTecnologicas">
      <div class="area-container" id="{{ area.id }}" *ngFor="let area of areasTecnologicas">
        <h2 class="area-title">{{ area.nome }}</h2>
        <p class="area-descricao text-justify">{{ area.descricao }}</p>
        <div style="display: flex">
          <div style="width: 48px; height: auto;"></div>
          <button class="btn-area rounded-pill btn-lg btn-primary"
            (click)="showCursosAreas({eixo: eixo.id, areatecnologica: area.id})">
            Acessar cursos
          </button>
          <div style="width: 48px; height: auto;"></div>
        </div>
      </div>
    </div>
  </div>

  <!-- Cursos -->
  <div class="container">
    <div *ngIf="!mostrarAreasTecnologicas">
      <!-- <app-barra-busca [eixos]="eixos" [componenteRef]="componenteRef"
        (inputEvent)="recebeuInput($event)"></app-barra-busca> -->
      <section class="response">
        <p *ngIf="totalResultados" class="text-center results">
          Total de resultados encontrados: {{ totalResultados }}
        </p>
        <p *ngIf="!totalResultados || (!totalResultados && realizouBusca)" class="text-center results">
          Desculpe, não encontramos nenhum resultado compatível com sua busca.
        </p>
      </section>
    </div>

    <!-- <p class="page-number" *ngIf="totalPaginas > 0">página {{ paginaAtual }}</p> -->
    <div *ngIf="cursos.length > 0 && mostrarCursos">
      <ul>
        <li class="card bg-color-white contrast-border" *ngFor="let curso of cursos">
          <app-card [titulo]="curso.nome" [texto]="curso.perfilProfissional" [id]="curso.id"
            [tipo]="curso.tipo"></app-card>
        </li>
      </ul>

      <!--Ver paginação -->
      <app-paginacao [paginaAtual]="paginaAtual" [totalPaginas]="totalPaginas"
        (mudouPagina)="onPaginaSelecionada($event)"></app-paginacao>
    </div>
  </div>

  <!-- <div class="container">
    <p class="text-center text-uppercase negrito">Acessar demais cursos desse eixo</p>
    <div class="btn-container container">
      <a [routerLink]="['/cursos']" [queryParams]="{ filtro: 'mudaramnome', eixo: eixo.id }"
        class="btn btn-dark link btn-xl rounded-pill">CONVERGÊNCIAS<span class="tooltip color-white">Denominação
          Atual</span></a>
      <a [routerLink]="['/cursos']" [queryParams]="{ filtro: 'naopermitidos', eixo: eixo.id }"
        class="btn btn-dark link  btn-xl rounded-pill">SUBMISSÕES<span class="tooltip color-white">Excluídos ou não
          incluídos</span></a>
    </div>
  </div> -->
</main>